import React from 'react';

import Container from '@common/Container';
import Section from '@common/Section';
import Heading from '@common/Heading';
import Row from '@common/Row';
import Card from '@common/blocks/list/resource-cards/Card';

const ResourceCards = ({ data }) => {
  const {
    title,
    showTitle,
    list
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Row className='row-cols-lg-2 row-cols-xl-3 g-3'>
            {list.map(resource => (
              <Card key={resource.id} data={resource} />
            ))}
          </Row>
        }
      </Container>
    </Section>
  )
}

export default ResourceCards
